import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Swal from "sweetalert2";

export const postActivity = createAsyncThunk(
  "countries/postActivity",
  async (payload) => {
    const inputActivity = await axios
      .post(
        "https://sleepy-fjord-53264.herokuapp.com/countries/create",
        payload
      )
      .catch((Err) => {});
    return inputActivity.data;
  }
);

export const getCountryByName = createAsyncThunk(
  "countries/getCountryByName",
  async (payload) => {
    const response = await axios
      .get(`https://sleepy-fjord-53264.herokuapp.com/countries?name=${payload}`)
      .catch((error) => {
        return error.data;
      });
    return response.data;
  }
);
export const getAllCountries = createAsyncThunk(
  "countries/getAllCountries",
  async () => {
    const response = await axios
      .get("https://sleepy-fjord-53264.herokuapp.com/countries")
      .catch((Error) => {
        return Error.data;
      });
    return response.data;
  }
);
export const getByContinent = createAsyncThunk(
  "countries/getAllCountries",
  async (payload) => {
    const response = await axios
      .get(
        `https://sleepy-fjord-53264.herokuapp.com/filterContinent?name=${payload}`
      )
      .catch((Error) => {
        return Error.data;
      });
    return response.data;
  }
);
const initialState = {
  countries: [],
};

const getCountries = createSlice({
  name: "countries",
  initialState,
  reducers: {
    sortByName: (state, action) => {
      switch (action.payload) {
        case "AtoZ":
          state.countries = state.countries.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          break;
        case "ZtoA":
          state.countries = state.countries.sort((a, b) =>
            b.name.localeCompare(a.name)
          );
          break;
        default:
          break;
      }
    },
    sortByPopulation: (state, action) => {
      switch (action.payload) {
        case "Mtom":
          state.countries = state.countries.sort(
            (a, b) => b.population - a.population
          );
          break;
        case "mtoM":
          state.countries = state.countries.sort(
            (a, b) => a.population - b.population
          );
          break;
        default:
          break;
      }
    },
  },
  extraReducers: {
    [getAllCountries.pending]: () => {},
    [getAllCountries.fulfilled]: (state, action) => {
      return { countries: action.payload };
    },
    [getByContinent.pending]: () => {},
    [getByContinent.fulfilled]: (state, action) => {
      return { countries: action.payload };
    },
    [getCountryByName.pending]: () => {},
    [getCountryByName.fulfilled]: (state, action) => {
      return { countries: action.payload };
    },
    [postActivity.pending]: () => {},
    [postActivity.fulfilled]: () => {
      Swal.fire({ icon: "success", text: "Activity created" }).then(
        (result) => {
          window.location.reload();
        }
      );
    },
  },
});
export const { sortByName, sortByPopulation } = getCountries.actions;
export default getCountries.reducer;

export const allCountries = (state) => state.countries.countries;
